import React, { useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import {
  getDefaultEventRegistrationFormData,
  EVENT_REGISTRATION_FORM_BLOCK_ID,
} from './defaults';

// The chooser inserts a block of @type 'eventRegistrationForm'. This shim runs
// once, replaces it with a fully-populated schemaForm (+ eventRegistration flag)
// via a single onChangeBlock. Volto then re-renders the block with schemaForm's
// edit (keyed on @type). See spec §3.2 / blocking item #1.
const EditEventRegistrationForm: React.FC<any> = (props) => {
  const intl = useIntl();
  const morphed = useRef(false);
  const { onChangeBlock, block, data } = props;

  useEffect(() => {
    if (morphed.current) return;
    if (data?.['@type'] === EVENT_REGISTRATION_FORM_BLOCK_ID) {
      morphed.current = true;
      onChangeBlock(block, getDefaultEventRegistrationFormData(intl));
    }
  }, [block, data, intl, onChangeBlock]);

  return null; // brief: replaced by schemaForm edit after onChangeBlock
};

export default EditEventRegistrationForm;
